module.exports = __webpack_public_path__ + "assets/img/Type E (17).2e2a05ac.jpg";